import { render, staticRenderFns } from "./metric-identifier.vue?vue&type=template&id=82e83896&"
import script from "./metric-identifier.vue?vue&type=script&lang=js&"
export * from "./metric-identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports